module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/about-311.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/vux-loader/about.md
// module id = 778
// module chunks = 470